import { Modification } from '@/types/api/api-v3/product'
import type { NewProductModification } from '@/types/api/api-v4/product'
import type { ProductV5Modification } from '@/types/api/api-v5/product'

export type CommonProductModification = Partial<
  Modification | NewProductModification | ProductV5Modification
>

export enum NAME_PARENT_COMPONENT {
  MAIN_DESKTOP = 'mainDesktop',
  MAIN_MOBILE = 'mainMobile',
  DIALOG = 'dialog',
  PAGE = 'page',
}

export enum TagSize {
  'NORMAL' = 'NORMAL',
  'LARGE' = 'LARGE',
  'SMALL' = 'SMALL',
}
